import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import cns from 'classnames';
import { Field } from 'redux-form';
import { Button } from 'react-bootstrap';

import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';

class SubSkillsFieldArray extends Component {
    static propTypes = {
        fields: PropTypes.any,
        contentValues: PropTypes.array,
        disabled: PropTypes.bool
    };

    _pushField = () => {
        const { fields } = this.props;

        if (fields.length <= 4) {
            fields.push({
                id: uuid()
            });
        }
    };

    _removeField = (index) => {
        const { fields } = this.props;

        fields.remove(index);
    };

    _moveUp = (index) => {
        const { fields } = this.props;

        if (index) {
            fields.swap(index, index - 1);
        }
    };

    _moveDown = (index) => {
        const { fields } = this.props;

        if (index < fields.length - 1) {
            fields.swap(index, index + 1);
        }
    };

    render() {
        const { fields, contentValues, disabled } = this.props;

        const fieldsArray = fields.map((name, index) => (
            <div key={contentValues.subSkills[index].id}>
                <h5 className={'block-heading'}>{`SUBSKILL  #${index + 1}`}</h5>
                <Button onClick={() => this._moveUp(index)} className={'chooseSectionItem-swapUp col-sm-4 col-12'}>
                    <i className={'fa fa-angle-up'} />
                </Button>
                <Button onClick={() => this._moveDown(index)} className={'chooseSectionItem-swapDown col-sm-4 col-12'}>
                    <i className={'fa fa-angle-down'} />
                </Button>
                <Button onClick={() => this._removeField(index)} className={'chooseSectionItem-delete col-sm-4 col-12'}>
                    <i className={'fa fa-trash'} />
                </Button>
                <Field
                    name={`${name}.title`}
                    label={'Skill Assessed (20 characters max)'}
                    className={'col-12 subSkill-prompt'}
                    placeholder={'Enter a Skill'}
                    component={BasicText}
                    disabled={disabled}
                />
            </div>
        ));

        return (
            <div className={'col-12'}>
                {fieldsArray}
                <Button
                    onClick={this._pushField}
                    className={cns('chooseSectionItem-addField fa fa-plus fa-large', {
                        hidden: fields.length > 4 || disabled
                    })}
                />
            </div>
        );
    }
}

export default SubSkillsFieldArray;
